import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  MenuItem,
  FormHelperText,
  Select,
  InputLabel,
  CircularProgress,
  IconButton,
  Tooltip,
  Grid,
  Typography
} from '@mui/material';

import { FaArrowLeft, FaPlus, FaPencilAlt, FaCheck, FaCheckCircle } from "react-icons/fa";

import { editDocLegal, clearErrors, getDocsLegal } from '../../../redux/actions/dataactions';
import './DocumentoEditar.css';

class DocumentoEditar extends Component {
  state = {
    tipodoc: '',
    descripcion: '',
    consecutivo: '',
    errors: {},
    aprobado: {},
    open: false
  };

  mapUserDetailsToState = (doc) => {
    this.setState({
      tipodoc: doc.tipodoc || '',
      descripcion: doc.descripcion || '',
      consecutivo: doc.consecutivo || ''
    });
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length ? newState : null;
  }

  componentDidMount() {
    this.mapUserDetailsToState(this.props.doc);
  }

  handleOpen = () => {
    this.setState({ open: true });
    this.mapUserDetailsToState(this.props.doc);
  };

  handleClose = () => {
    this.props.clearErrors();

    if (this.state.aprobado?.mensaje) {
      this.setState({ open: false, aprobado: {}, errors: {} });
      this.props.getDocsLegal(this.props.clienteId);
    } else {
      this.setState({ open: false, errors: {} });
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { tipodoc, descripcion, consecutivo } = this.state;
    const newDocData = {
      tipodoc,
      descripcion,
      consecutivo,
      clienteid: this.props.clienteId
    };
    this.props.editDocLegal(newDocData, this.props.clienteId, this.props.docId);
  };

  render() {
    const { UI: { loading } } = this.props;
    const { open, aprobado, errors, tipodoc, descripcion, consecutivo } = this.state;

    return (
      <Fragment>
        <Tooltip title="Editar Documento">
          <IconButton onClick={this.handleOpen}>
            <FaPencilAlt color="#03178C" className="documento-editar-icon" />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="sm">
          {aprobado?.mensaje ? (
            <div className='documento-editar-aprobado'>
              <div className='documento-editar-icono-container'>
                <FaCheck color="#ffffff" className='documento-editar-icono' />
              </div>
              <h2 className='documento-editar-texto'>¡Documento Actualizado Exitosamente!</h2>
            </div>
          ) : (
            <>
              <DialogTitle><Typography sx={{ 
                                  fontSize: '20px', 
                                  fontWeight: 400, 
                                  color: '#0468BF', 
                                  textAlign: 'start' 
                                  }}>
                                  Editar Documento
                  </Typography></DialogTitle>
              <DialogContent>
                <form>
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!!errors.tipodoc}>
                        <InputLabel>Tipo Documento</InputLabel>
                        <Select
                          name="tipodoc"
                          value={tipodoc}
                          onChange={this.handleChange}
                          required
                          label="Tipo Documento"
                        >
                          <MenuItem value=""><em></em></MenuItem>
                          <MenuItem value="Contrato">Contrato</MenuItem>
                          <MenuItem value="Factura">Factura</MenuItem>
                          <MenuItem value="Hoja de Vida">Hoja de Vida Ingeniero</MenuItem>
                          <MenuItem value="Registro Invima">Registro Invima</MenuItem>
                          <MenuItem value="Programa de Tecnovigilancia">Programa de Tecnovigilancia</MenuItem>
                          <MenuItem value="Programa de Capacitaciones">Programa de Capacitaciones</MenuItem>
                          <MenuItem value="Programa de Mantenimiento">Programa de Mantenimiento</MenuItem>
                          <MenuItem value="Certificado de Patron">Certificado de Patron</MenuItem>
                          <MenuItem value="Capacitacion">Capacitación</MenuItem>
                          <MenuItem value="Protocolo de Tecnologia">Protocolo de Tecnología</MenuItem>
                          <MenuItem value="Programa Metrologico">Programa Metrológico</MenuItem>
                        </Select>
                        <FormHelperText>{errors.tipodoc}</FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Descripción"
                        name="descripcion"
                        value={descripcion}
                        onChange={this.handleChange}
                        error={!!errors.descripcion}
                        helperText={errors.descripcion}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Consecutivo"
                        name="consecutivo"
                        value={consecutivo}
                        onChange={this.handleChange}
                        error={!!errors.consecutivo}
                        helperText={errors.consecutivo}
                      />
                    </Grid>

                    {errors?.error && (
                      <Grid item xs={12}>
                        <p className="documento-editar-error-message">{errors.error}</p>
                      </Grid>
                    )}
                  </Grid>
                </form>
              </DialogContent>
            </>
          )}

          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" className="documento-editar-form-icon" />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="primary" className="documento-editar-progress" />
            ) : aprobado?.mensaje ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleClose}>
                  <FaCheckCircle color="#20B90C" className="documento-editar-form-icon" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Actualizar Documento">
                <span>
                  <IconButton
                    onClick={this.handleSubmit}
                    disabled={!tipodoc || !descripcion || !consecutivo}
                  >
                    <FaPlus color="#03178C" className="documento-editar-form-icon" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DocumentoEditar.propTypes = {
  editDocLegal: PropTypes.func.isRequired,
  getDocsLegal: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  doc: PropTypes.object.isRequired,
  docId: PropTypes.string.isRequired,
  clienteId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

export default connect(mapStateToProps, { editDocLegal, clearErrors, getDocsLegal })(DocumentoEditar);
